export default "https://cdn-static.gokick.com/assets/c0e4f86ff5da21e4b09546702d214e718bb56dad/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";